import { render } from "./NewEvent.vue?vue&type=template&id=05a452bd&scoped=true"
import script from "./NewEvent.vue?vue&type=script&lang=js"
export * from "./NewEvent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-05a452bd"

export default script